import type { PropsWithChildren } from "react";
import styles from "~/features/products/ProductCard/ProductCard.module.css";

export const Content = ({ children }: PropsWithChildren) => (
	<div className={styles["product-card__content"]}>{children}</div>
);
